export interface LocaleConfig {
  code: string
  name: string
  dir: 'ltr' | 'rtl'
  dateLocale: string
  currency: string
}

export const defaultLocale = 'ru'

export const supportedLocales: LocaleConfig[] = [
  {
    code: 'ru',
    name: 'Русский',
    dir: 'ltr',
    dateLocale: 'ru-RU',
    currency: 'RUB',
  },
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    dateLocale: 'en-US',
    currency: 'USD',
  },
]

export const supportedLocaleCodes = supportedLocales.map((l) => l.code)

export function getLocaleConfig(code: string): LocaleConfig {
  return supportedLocales.find((l) => l.code === code) || supportedLocales[0]
}

export function detectLocale(): string {
  const saved = localStorage.getItem('user-locale')
  if (saved && supportedLocaleCodes.includes(saved)) return saved

  const browserLangs = navigator.languages || [navigator.language]
  for (const lang of browserLangs) {
    const code = lang.split('-')[0]
    if (supportedLocaleCodes.includes(code)) return code
  }

  return defaultLocale
}
